import { render, staticRenderFns } from "./SlideNavigation.vue?vue&type=template&id=97185724&scoped=true"
import script from "./SlideNavigation.vue?vue&type=script&lang=js"
export * from "./SlideNavigation.vue?vue&type=script&lang=js"
import style0 from "./SlideNavigation.vue?vue&type=style&index=0&id=97185724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97185724",
  null
  
)

export default component.exports